import { useState, useEffect } from "react";
import api from "@/lib/api";
import { ImageOff, Loader2 } from "lucide-react";

export function AuthImage({ path, alt = "", className = "" }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let active = true;
    let obj = null;
    setUrl(null);
    setErr(false);
    if (!path) {
      setErr(true);
      return;
    }
    api
      .get(`/files/${path}`, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        obj = URL.createObjectURL(res.data);
        setUrl(obj);
      })
      .catch(() => active && setErr(true));
    return () => {
      active = false;
      if (obj) URL.revokeObjectURL(obj);
    };
  }, [path]);

  if (err)
    return (
      <div className={`flex flex-col items-center justify-center bg-slate-800 text-slate-500 gap-1 ${className}`}>
        <ImageOff className="h-5 w-5" />
        <span className="text-[10px]">Sem foto</span>
      </div>
    );
  if (!url)
    return (
      <div className={`flex items-center justify-center bg-slate-800 ${className}`}>
        <Loader2 className="h-5 w-5 animate-spin text-slate-500" />
      </div>
    );
  return <img src={url} alt={alt} className={className} />;
}
